import React from "react";
import {   
  Dialog,
  DialogSurface,
  DialogTitle,
  DialogBody,
  DialogActions,
  DialogContent,
  Button,
  DialogTrigger, } from "@fluentui/react-components";

const AlertPopup = ({open, handleClose, text, title}) => {

    return (
    <Dialog open={open}>
            <DialogSurface style={{ width: "50%" }}>
              <DialogBody style={{ padding: '.5rem' }}>
                <DialogTitle style={{ fontSize: '12px' }}>{title}</DialogTitle>
                <DialogContent>
                 <div className="dialog-text">
                    <p className="font-normal py-0 px-0 text-xs text-gray-700">{text}</p>
                 </div>
                </DialogContent>
              <DialogActions>
<div className="rounded-md fixed bottom-0 left-0 right-0 flex justify-end h-12 mr-4 gap-2 py-2 bg-white shadow-md">
                     <DialogTrigger disableButtonEnhancement>
                       <Button 
                        className="btn-com-cancel"
                        onClick={handleClose}>
                         Close
                       </Button>
                     </DialogTrigger>
                   </div>
              </DialogActions>
              </DialogBody>
            </DialogSurface>
          </Dialog>
    )
}

export default AlertPopup;